"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CountrySelectField = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _SelectDialogField = _interopRequireDefault(require("@concur/nui-widgets/lib/SelectDialog/SelectDialogField"));
var _SelectionList = _interopRequireDefault(require("@concur/nui-widgets/lib/SelectDialog/SelectionList"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // Widgets
var CountrySelectField = exports.CountrySelectField = function CountrySelectField(_ref) {
  var onSelect = _ref.onSelect,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? [] : _ref$value,
    formatter = _ref.formatter,
    _ref$countries = _ref.countries,
    countries = _ref$countries === void 0 ? [] : _ref$countries;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    temporarilySelectedCountries = _useState4[0],
    setTemporarilySelectedCountries = _useState4[1];
  var _useState5 = (0, _react.useState)(countries),
    _useState6 = _slicedToArray(_useState5, 2),
    filteredCountries = _useState6[0],
    setFilteredCountries = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = _slicedToArray(_useState7, 2),
    searchQuery = _useState8[0],
    setSearchQuery = _useState8[1];
  (0, _react.useEffect)(function () {
    setFilteredCountries(countries.filter(function (country) {
      return country.description.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase());
    }));
  }, [searchQuery]);
  return /*#__PURE__*/_react.default.createElement(_SelectDialogField.default, {
    clearFieldAriaLabel: formatter.formattedMessage({
      id: 'AppCenterV2.home.filters.countriesRegions.clearFieldAriaLabel'
    }),
    dialogTriggerAriaLabel: formatter.formattedMessage({
      id: 'AppCenterV2.home.filters.countriesRegions.addonLabel'
    }),
    label: formatter.formattedMessage({
      id: 'AppCenterV2.home.filters.countriesRegions.title2'
    }),
    dialogTriggerButtonProps: {
      tabIndex: '-1' // UIA11Y-7763: The dialog trigger button should not be tabbable. Temporary fix until fixed by the coreui team.
    },
    dialogProps: {
      dimensions: {
        minWidth: '900px',
        minHeight: '540px'
      }
    },
    onClearField: function onClearField() {
      onSelect([]);
    },
    selectView: {
      title: formatter.formattedMessage({
        id: 'AppCenterV2.home.filters.countriesRegions.title2'
      }),
      body: /*#__PURE__*/_react.default.createElement(_SelectionList.default, {
        placeholder: formatter.formattedMessage({
          id: 'AppCenterV2.home.filters.countriesRegions.title2'
        }),
        selectionFilterProps: {
          value: searchQuery,
          onChange: function onChange(event) {
            var _event$target;
            setSearchQuery(event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
          }
        },
        filterLabel: formatter.formattedMessage({
          id: 'AppCenterV2.home.filters.countriesRegions.filterLabel'
        }),
        listboxProps: {
          selectionType: 'multiSelect',
          onSelectionChange: function onSelectionChange(_, eventKey) {
            var index = temporarilySelectedCountries.findIndex(function (country) {
              return country.code === eventKey;
            });
            if (index < 0) {
              setTemporarilySelectedCountries([].concat(_toConsumableArray(temporarilySelectedCountries), [countries.find(function (country) {
                return country.code === eventKey;
              })]));
            } else {
              setTemporarilySelectedCountries([].concat(_toConsumableArray(temporarilySelectedCountries.slice(0, index)), _toConsumableArray(temporarilySelectedCountries.slice(index + 1))));
            }
          },
          itemKey: 'code',
          selectedKeys: temporarilySelectedCountries.map(function (country) {
            return country.code;
          }),
          listItemRenderer: 'description'
        },
        options: filteredCountries
      }),
      isMultiSelect: true,
      cancelLabel: formatter.formattedMessage({
        id: 'Cancel'
      }),
      confirmLabel: formatter.formattedMessage({
        id: 'Ok'
      }),
      onConfirm: function onConfirm() {
        onSelect(temporarilySelectedCountries);
        setOpen(false);
      }
    },
    value: value.map(function (selectedCountry) {
      return selectedCountry.description;
    }).join(', '),
    onOpen: function onOpen() {
      setTemporarilySelectedCountries(value);
      setSearchQuery('');
      setOpen(true);
    },
    onClose: function onClose() {
      setOpen(false);
    },
    showDialog: open
  });
};
CountrySelectField.propTypes = {
  onSelect: _propTypes.default.func.isRequired,
  value: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  formatter: _propTypes.default.shape({
    formattedMessage: _propTypes.default.func.isRequired
  }).isRequired,
  countries: _propTypes.default.arrayOf(_propTypes.default.object)
};
var _default = exports.default = (0, _nuiIntlRuntime.withFormatter)(CountrySelectField);